export function ermsService(http) {
    const serviceName = "Erms";

    return {

        getSubDisiplines:(disciplineId)=>{
            return http.get(serviceName + `/GetSubDisciplines?disciplineId=${disciplineId}`);
        },
        getSubDisiplinesWithParent:(disciplineId)=>{
            return http.get(serviceName + `/GetSubDisciplinesWithParent?disciplineId=${disciplineId}`);
        },
        getActivityBudget:(activityId,keyId)=>{
            
            return http.get(serviceName + `/GetActivityBudget?activityId=${activityId}&keyId=${keyId||0}`);
        },
        getProjectsByRoleMember:(roleMembers)=>{
            const data=roleMembers;
            return http.post(serviceName+"/GetProjectsByRoleMember",data);
        },
        getAllProjects:()=>{
            return http.get(serviceName+"/GetAllProjects");
        },
        getKeyData:(keyId)=>{
            return http.get(`${serviceName}/GetKeyData?keyId=${keyId}`);
        },
        getFiles:(id)=>{
            return http.get(serviceName+`/GetFiles?idRepositoryId=${id}`);
        },
        getFilesInTask:(id,consumedId)=>{
            return http.get(serviceName+`/GetFilesInTask?keyId=${id}&consumedId=${consumedId}`);
        },
        getDocumentHistoryAtStage:(id)=>{
            return http.get(serviceName+`/GetTaskAllHistory?documentId=${id}`);
        },
        getDisciplineEmployees:(user)=>{
            const data=user;
            return http.post(serviceName+"/GetDisciplineEmployees",data);
        },
        getSubDisciplineEmployees:(user)=>{
            const data=user;
            return http.post(serviceName+"/GetSubDisciplineEmployees",data);
        },








        // getEmployeeNotAssign:(disciplineId,employmentCostCenterCode,employmentCostCenterSubCode,startDate,dueDate,cartableTypeId)=>{
        //     const data={
        //         disciplineId,
        //         startDate,
        //         dueDate,
        //         cartableTypeId,
        //         employmentCostCenterCode,
        //         employmentCostCenterSubCode
        //     }
        //     return http.post(serviceName + "/GetEmployeeNotAssign",data)
        // },


        coordinatorDoneAction: (userId,activityId,activityCode,documentId,
                                disciplineId,
                                responsibleDisciplineId,projectId,
                                statusTypeId,holdReasonId,priorityTypeId,
                                keyStatusTypeId,
                                homaLastDocumentRevision,
                                homaLastDocumentStatusCode,
                                homaTransmittalDetailId,
                                statusType
                                ) => {
            const data=[{
                userId,
                key:{
                    activityId,
                    activityCode,
                    documentId,
                    keyStatusTypeId,
                    projectId,
                    homaTransmittalDetailId,
                    createUserId:userId,
                    determineStatusTask:{
                        statusTypeId,
                        statusType,
                        holdReasonId,
                        priorityTypeId,
                        homaLastDocumentRevision,
                        homaLastDocumentStatusCode
                    }
                },
                project:{
                    id:projectId
                },
                discipline:{
                    id:disciplineId,
                    responsibleDisciplineId
                }
            }]
            return http.post(serviceName + "/CoordinatorDoneAction",data)
        },
        coordinatorDoneActionBulk: (userId,keyType,tasks) => {
            //debugger;
            const bulkMessage=tasks.map(entity=>{
                return {
                    activityCode:entity.activityCode,
                    documentId:entity.documentId,
                    statusTypeId:entity.statusId,
                    needReason:entity.needReason,
                    holdReasonId:entity.holdReasonId,
                }
            });

            const data={
                userId,
                keyType,
                bulkMessage
            }
            return http.post(serviceName + "/CoordinatorDoneActionBulk",data)
        },
        addAssignResponsibles:(keyId,userId,uniqueId,activityTypeId,responsibles)=>{
            const data={
                        keyId,
                        userId,
                        uniqueId,
                        activityTypeId,
                        responsibles
            }
            return http.post(serviceName + "/AddAssignResponsibles",data)
        },
        approveResponsible:(keyId,userId,doerUserId,jobUniqueId)=>{
            const data={
                        keyId,
                        user:{
                            id:userId
                        },
                        doerUserId,
                        jobUniqueId
            }
            return http.post(serviceName + "/ApproveResponsible",data)
        },
        headSectionFinal:(keyId,keyGId,keyStatusTypeId,userId,jobUniqueId)=>{
            const data={
                        keyId,
                        keyGId,
                        keyStatusTypeId,
                        user:{
                            id:userId
                        },
                        jobUniqueId
            }
            return http.post(serviceName + "/HeadSectionFinal",data)
        },

        deleteAssignedResponsible(id){
            //debugger;
            const data={
                   assign:{
                       id
                   }
                };
            return http.post(serviceName + "/DeleteAssignedResponsible",data)
        },
        updateAssignedResponsible(id,responsibleTypeId,total){
            const data={
                assign:{
                    id,
                    responsibleTypeId,
                    total
                }
            }
            return http.post(serviceName + "/UpdateAssignedResponsible",data)
        },
        setTaskAttribute:(data)=>{
            return http.post(serviceName + "/SetTaskAttribute",data)
        },
        headSectionAssignAction:(keyId,keyGId,userId,uniqueId,)=>{
            const data={
                        userId,
                        uniqueId,
                        keyId,
                        keyGId
            }
            return http.post(serviceName + "/HeadSectionAssignAction",data)
        },

        insertResponsibleManHourConsume:(activityTypeId, responsibleActionTypeId,uniqueId,userId, assignId,doDate,manHour,progress,isOverTime,remark,files)=>{
            const data={
                activityTypeId,
                responsibleActionTypeId,
                uniqueId,
                user:{
                    userId
                },
                ConsumedManHourInsert:{
                    assignId,
                    doDate,
                    manHour,
                    progress,
                    isOverTime,
                    remark
                },
                uploadfiles:files.map(item=>({MediaInfo:{
                    originalFileName:item.fileName,
                    fileType: item.fileType,
                    TemporaryFileName: item.fileId
                }}))
                    
            }
            return http.post(serviceName + "/InsertResponsibleManHourConsume",data)
        },

        updateResponsibleManHourConsume:(id, activityTypeId, responsibleActionTypeId,uniqueId,userId, assignId,doDate,manHour,progress,isOverTime,remark,files)=>{
            const data={
                id,
                activityTypeId,
                responsibleActionTypeId,
                uniqueId,
                user:{
                    userId
                },
                ConsumedManHourInsert:{
                    assignId,
                    doDate,
                    manHour,
                    progress,
                    isOverTime,
                    remark
                },
                uploadfiles:files.map(item=>({MediaInfo:{
                    originalFileName:item.fileName,
                    fileType: item.fileType,
                    TemporaryFileName: item.fileId
                }}))
                    
            }
            return http.post(serviceName + "/UpdateResponsibleManHourConsume",data)
        },
        deleteResponsibleManHourConsume:(id)=>{
            const data={
                id
            }
            return http.post(serviceName + "/DeleteResponsibleManHourConsume",data)
        },
        getResponsibleConsumedManHour:(assignId,date)=>{
            const data={
                assignId,
                date
            }
            return http.post(serviceName + "/GetResponsibleConsumedManHour",data)
        },
        ResponsibleSchaduler:(userId)=>{
            const data={
                userId
            }
            return http.post(serviceName + "/GetResponsibleSchaduler",data)
        },
        getResponsibleTimesheetsByUserId:(keyId,userId)=>{
            const data={
                keyId,
                userId
            }
            return http.post(serviceName + "/GetResponsibleTimesheetsByUserId",data)
        },
        getResponsibleTimesheetsByAssignId:(assignId)=>{
            const data={
                assignId
            }
            return http.post(serviceName + "/GetResponsibleTimesheetsByAssignId",data)
        },
        // getTaskHistory:(keyId)=>{
        //     const data={
        //         keyId
        //     }
        //     return http.post(serviceName + "/GetTaskHistory",data)
        // },
        getTaskHistory:(keyId)=>{

            // const newSortBy=(sortBy||[]).map(item=>( {member:item.id,sortDirection:item.desc?"Descending":"Ascending"}))


            // const data={
            //     keyId,
            //     dataAttribute:{
            //         page:pageindex+1,
            //         pageSize,
            //         sorts:newSortBy||[],
            //         //filter:filter
            //     }
            // }
            return http.get(`${serviceName}/GetTaskHistory?keyId=${keyId}`);
        },
        saveCustomActivity:(formData,user,responsibles)=>{
            const data={
                type:formData.type,
                roleTypeId:formData.roleTypeId,
                customActivity:{
                    projectId:formData.projectId,
                    code:formData.code,
                    activityId:formData.activityId,
                    documentId:formData.documentId,
                    startDate:formData.startDate,
                    dueDate:formData.dueDate,
                    disciplineId:formData.disciplineId,
                    description:formData.description,
                    standardActivityId:formData.standardActivityId
                },
                responsibles:responsibles||[],
                roleMembers:[],
                user:{
                    id:user.userId
                }
            }
            return http.post(serviceName + "/CoordinatorSaveCustomActivity",data)
        },
        
        getEmployeeNotAssign:(disciplineId,employmentCostCenterCode,employmentCostCenterSubCode,startDate,dueDate,cartableTypeId)=>{
            const data={
                disciplineId,
                startDate,
                dueDate,
                cartableTypeId,
                employmentCostCenterCode,
                employmentCostCenterSubCode
            }
            return http.post(serviceName + "/GetEmployeeNotAssign",data)
        },
        getDisciplineSupervisors:(disciplineIds)=>{
            const _disciplineIds=disciplineIds.map(a=>`disciplineIds=${a}`).join('&');
            return http.get(serviceName + `/GetDisciplineSupervisors?${_disciplineIds}`);
        },
        getResponsibleAssigned:(keyId,disciplineId,startDate,dueDate)=>{
            const data={
                keyId,
                disciplineId,
                startDate,
                dueDate,
            }
            return http.post(serviceName + "/GetResponsibleAssigned",data)
        },

        getResponsibleConsumedManHours:(assignId)=>{
            const data={
                assignId
            }

            return http.post(serviceName + "/GetResponsibleConsumedManHours",data)
        },
        getDisciplineActivities:(disciplineId)=>{
            // const data={
            //     disciplineId
            // };
            // debugger;
            return http.get(serviceName+`/GetDisciplineStandardActivities?disciplineId=${disciplineId}`);
        },
        newAssignByHeadSection:(activityTypeId,assignId,jobUniqueId,currentUserId,headSectionActionTypeId,responsible)=>{
            const data={
                activityTypeId,
                assignId,
                jobUniqueId,
                headSectionActionTypeId,
                user:{
                    id:currentUserId
                },
                responsible
            };
            return http.post(serviceName+"/NewAssignByHeadSection",data);
        },
        getStandarActivities:(disciplineIds)=>{
            const _disciplineIds=disciplineIds.map(a=>`disciplineIds=${a}`).join('&');

            return http.get(serviceName+`/GetStandardActivities?${_disciplineIds}`);
        },
        getStandarActivity:(standardActivityId)=>{
            return http.get(serviceName+`/GetStandardActivity?standardActivityId=${standardActivityId}`);
        }


    }
}